export default require('./TabTrigger').default
